<div class="flex">
  <div class="f-basis--12 margin-graph">
    <div id="divGraphMap" echarts [options]="chartOptions" class="chart-scatter"></div>
  </div>
</div>
